import { Link } from "react-router-dom";
import { Home, Building2 } from "lucide-react";
import { useLanguage } from "../i18n";
import { useSEO } from "../seo";

const COPY = {
  it: {
    title: "Pagina non trovata | OGStay",
    desc: "La pagina che cerchi non esiste o è stata spostata.",
    kicker: "Errore 404",
    h: "Questa pagina è partita per la Sardegna senza avvisarci.",
    sub: "Il link che hai seguito non porta da nessuna parte. Ma l'Ogliastra è sempre qui che ti aspetta.",
    home: "Torna alla home",
    stays: "Scopri le strutture",
  },
  en: {
    title: "Page not found | OGStay",
    desc: "The page you are looking for does not exist or has been moved.",
    kicker: "Error 404",
    h: "This page left for Sardinia without telling us.",
    sub: "The link you followed leads nowhere. But Ogliastra is still here waiting for you.",
    home: "Back to home",
    stays: "Explore our homes",
  },
};

export default function NotFoundPage() {
  const { lang } = useLanguage();
  const c = COPY[lang];
  useSEO(c.title, c.desc);

  return (
    <div data-testid="not-found-page" className="flex min-h-screen items-center bg-warm px-5 pb-24 pt-36 sm:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <p className="kicker justify-center text-navy" data-testid="not-found-kicker">
          <span className="h-px w-8 bg-sky" />
          {c.kicker}
          <span className="h-px w-8 bg-sky" />
        </p>
        <h1 data-testid="not-found-title" className="mt-6 font-display text-4xl font-semibold leading-[1.1] tracking-tight text-navy sm:text-5xl">
          {c.h}
        </h1>
        <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-mute">{c.sub}</p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <Link data-testid="not-found-home-link" to="/" className="btn-primary !px-7 !py-3.5 text-sm">
            <Home className="h-4 w-4" />
            {c.home}
          </Link>
          <Link data-testid="not-found-stays-link" to="/strutture" className="btn-secondary !px-7 !py-3.5 text-sm">
            <Building2 className="h-4 w-4" />
            {c.stays}
          </Link>
        </div>
      </div>
    </div>
  );
}
